/**
 * FileField Component
 *
 * file 타입 필드를 렌더링하는 컴포넌트
 * 프로젝트의 FileUpload 컴포넌트 사용
 */

import { FileUpload } from '@/shared/ui/file-upload';

import type { BaseFieldProps } from './types';

/**
 * 파일 업로드 필드
 *
 * shared/ui의 FileUpload 컴포넌트를 사용하여 일관된 파일 업로드 UI 제공
 */
export function FileField({ field, value: _value, onChange, disabled, error }: BaseFieldProps) {
  return (
    <FileUpload
      id={field.id}
      name={field.name}
      accept={field.accept}
      disabled={disabled}
      error={!!error}
      errorMessage={error}
      onFileChange={(file) => {
        if (file) {
          onChange(file.name);
        } else {
          onChange('');
        }
      }}
    />
  );
}
